import { ReactNode } from 'react';
import LazyLoad from 'react-lazyload';

type Props = {
  offset: number;
  height: number;
  once?: boolean;
  // TODO Change to ReactNode when types have been fixed https://github.com/DefinitelyTyped/DefinitelyTyped/pull/33181
  children: JSX.Element;
  placeholder?: ReactNode;
  unmountIfInvisible?: boolean;
};

const LazyLoadWrapper = ({ children, ...props }: Props) => (
  <LazyLoad {...props}>{children}</LazyLoad>
);

export const triggerLazyLoad = () => {
  if (typeof Event === 'function') {
    window.dispatchEvent(new Event('scroll'));
  } else if (typeof Event === 'object') {
    const event = document.createEvent('Event');
    event.initEvent('scroll', true, true);
    window.dispatchEvent(event);
  }
};

export default LazyLoadWrapper;
